export const isValidCssColor = (color) => {
    if (typeof color !== 'string') {
        return false;
    }

    return window.CSS.supports('color', color);
};
